import React from "react"
import PropTypes from "prop-types";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import '../v2/styles/_call-to-action.module.scss';

const CallToActionSmall = ({ title = "Optimize More. Worry Less. With Middleware.", isDemoBtn = false }: { title?: string, isDemoBtn?: boolean }) => {
    const { t } = useTranslation("common");
    
    return <>
        <section className={`call-to-action-sm`}>
            <div className={'container'}>
                <div className={'d-flex'}>
                    <h2>{t('commonCTA.title')}</h2>
                    <div className={"buttons"}>
                        <Link href={"https://app.middleware.io/auth/register/"} target={"_blank"} className={"ahref-btn primary"}>{t('cta.getStartedSimple')}</Link>
                        {isDemoBtn ? <Link href={"/demo-request/"} className={"ahref-btn secondary"} prefetch={false}>{t('commonCTA.bookDemo')}</Link> :  <Link href={"/pricing/"} className={"ahref-btn secondary"} prefetch={false}>{t('cta.viewPricing')}</Link>}
                    </div>
                </div>
            </div>
        </section>
    </>
}

CallToActionSmall.propTypes = {
    title: PropTypes.string,
    isDemoBtn: PropTypes.bool
}
export default CallToActionSmall